export enum PasswordOptionEnum {
  WITHOUT_PASSWORD_NOTIFY = 'without_password_notify',
  WITHOUT_PASSWORD_NO_NOTIFY = 'without_password_no_notify',
  WITH_PASSWORD = 'with_password',
}
